module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXBAMAAADjD5IeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTP+VAP+VAP+VAP+VAP+VAP+VAP+VAP+VAP+VAP+VAJhCPMQAAAAKdFJOUwAZftkI7zpelbX8HNk2AAAACXBIWXMAAABIAAAASABGyWs+AAAAlElEQVQY02NgAIFkMwY4YIxaKgDncKxa1QDnSK1atRDO0Vq1ahGcY7Vq1WKo7rSiVUCgngY0Q8JqFRQsbmSAs0FKoxCcpSCTYGARAyeCM4WBZRaMvdKBgcEDxmkBWVQFYS+HuQwEIK5DkYGasBLMiYJZCQQsMNNAnmUE0mbJUA5QJsiBRXXVKgeQOlUjoBijchADAwDq4WdLBOt/awAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/powerful/majorquery/major_query_five_star.png
// module id = 822
// module chunks = 0